module.exports = __webpack_public_path__ + "static/media/bindOutlook2.a31e40ae.png";